import { createElementVNode as _createElementVNode, openBlock as _openBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "hidden",
  id: "btn"
}
const _hoisted_2 = { class: "bg-white flex bg-opacity-50 hover:bg-cyan shadow-lg rounded-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "md:w-7 w-5",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M5 15l7-7 7 7"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_scroll_to = _resolveDirective("scroll-to")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_router_link, {
        to: "/",
        class: "p-1 md:p-3 text-dark-violet hover:text-white"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })), [
        [_directive_scroll_to, '#header']
      ])
    ])
  ]))
}